export default __webpack_public_path__ + "static/media/2.1ab965ca.png";